export default function setFullbanner() {
  const fullbanners = document.querySelectorAll('[data-fullbanner]');

  fullbanners.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    const slider = new Swiper(carousel, {
      slidesPerView: 1,
      watchOverflow: true,
      preloadImages: false,
      speed: 1000,
      lazy: {
        checkInView: true,
        loadPrevNext: false,
        loadOnTransitionStart: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
        disabledClass: '-disabled',
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

    slider.autoplay.stop();
    function startSwiper() {
      window.removeEventListener('scroll', startSwiper);
      window.removeEventListener('mousemove', startSwiper);
      slider.autoplay.start();
      //slider.autoplay.run();
    }
    window.addEventListener('scroll', startSwiper);
    window.addEventListener('mousemove', startSwiper);
  });
}
